import { DatePipe } from "@angular/common";
import {
        Component,
        EventEmitter,
        Input,
        OnInit,
        Output,
        TemplateRef,
        ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../../reducers";
import { Combo2Service, WorkOrderService } from "../../../../services/index";
import { JGRNService } from "../../../../services/jgrn.service";

declare var google;

@Component({
  selector: "bal-bit-inward",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./balanceBitInward.html",
})
export class balanceBitInward implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  statusList = ["PENDING", "INWARDED"];
  selected = [];
  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  tot_mtrs = 0;
  data: any;
  filter = {
    shirt_design: "",
    wo_no: "",
    order_from_date: "",
    order_to_date: "",
    wo_from_date: "",
    wo_to_date: "",
    fab_design: "",
    groupby: "wo_no",
    wo_id: "",
    wd_id : "",
    status : 'PENDING'
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "wo_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  rowDetails = [];
  isLoading: boolean = false;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  minMtrs: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private woservice: WorkOrderService,
    private modalService: BsModalService,
    public jgrn: JGRNService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    if (this.filter.groupby == "wo_no") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "WO Del Date",
          prop: "date",
          headerClass: "text-center",
          minWidth: 130,
          maxWidth: 130,
          width: 130,
        },
        {
          name: "WO Del No",
          prop: "rgrn_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "WO Date",
          prop: "fdate",
          headerClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Tot Bal.Mtrs",
          prop: "bal_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
        },
        {
          name: "Status",
          prop: "status",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },

        {
          name: "Production Status",
          prop: "production_status",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Add Stock",
          prop: "sno",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
        {
          name: "Print Barcode",
          prop: "sno",
          minWidth: 100,
          maxWidth: 100,
          headerClass: "text-center",
          width: 100,
          sortable: false,
          cellTemplate: this.printTemplate,
        }
      ];
    } else if (this.filter.groupby == "bit") {
      this.columns = [
        {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        },
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shade",
          prop: "shade",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Color",
          prop: "color",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Mtrs",
          prop: "bal_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
        }
        
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.shirt_design = "";
    this.filter.wo_no = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.filter.wo_from_date = "";
    this.filter.wo_to_date = "";
    this.filter.fab_design = "";
    this.filter.status = "PENDING";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }
  getBalanceBitDetails(row) {
    this.rowDetails = row;
    if (this.filter.groupby == "wo_no") {
      this.filter.groupby = "bit";
      this.filter.wo_id = row.wo_id;
      this.filter.wd_id = row.rgrn_id;
    }
    this.getColumns();
  }
  gobacktoWoGroup() {
    if (this.filter.groupby == "bit") {
      if (this.selected.length > 0) {
        swal("Please deselect all before going back");
        return;
      }
      this.filter.groupby = "wo_no";
      this.filter.wo_id = "";
      this.filter.wd_id = "";
      this.rowDetails = [];
    }
    this.getColumns();
  }
  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  getOrderList(): void {
    if (this.filter.wo_from_date !== "") {
      this.filter.wo_from_date = this.datePipe.transform(
        this.filter.wo_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.wo_to_date !== "") {
      this.filter.wo_to_date = this.datePipe.transform(
        this.filter.wo_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      shirt_design: this.filter.shirt_design,
      wo_no: this.filter.wo_no,
      wo_from_date: this.filter.wo_from_date,
      wo_to_date: this.filter.wo_to_date,
      fab_design: this.filter.fab_design,
      groupby: this.filter.groupby,
      wo_id: this.filter.wo_id,
      wd_id: this.filter.wd_id,
      status: this.filter.status,
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .balanceBitInward(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.minMtrs = res.minMtrs;
      });
  }
  getId(row) {
    return row.wo_bal_id;
  }
  getIdFunction() {
    return this.getId.bind(this);
    
  }
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    console.log(this.selected);
    this.tot_mtrs = 0;

    this.selected.forEach((el) => {
      this.tot_mtrs += el.bal_mtrs;
    });
    this.tot_mtrs = Math.round((this.tot_mtrs + Number.EPSILON) * 100) / 100;
  }
  addFabStock() {
    if (this.selected.length > 0) {
      let setTime = false;
      let setTimemm = 1000;
      let minMeter = this.minMtrs.filter(el => el.width == this.selected[0].width);

      let minExists = this.selected.some((el) => {
        return el.bal_mtrs < minMeter[0].min_mtr
      });
      
      let that = this;
      if(minExists){
        swal({
          title: "NOTE",
          text: "Meters less than " + minMeter[0].min_mtr + " will not be added to stock",
          type: "info",
          confirmButtonText: "OK!"
        });
        setTime = true;
      }
      if(setTime){
        setTimemm = 5000;
      }
      setTimeout(() => {
        swal({
          title: "Are you sure to add this bits to fabric stock?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Add it!",
          cancelButtonText: "No, want to change",
        }).then(function () {

          let params = {
            selected: JSON.stringify(that.selected),
            total_mtrs: that.tot_mtrs,
            min_mtr  : minMeter[0].min_mtr
          };
          that.isLoading = true;
          that.loadingIndicator = true;
          that.isLoadMask = that.woservice
            .addBalBitStock(params)
            .then(function (res: any) {
              that.loadingIndicator = false;
              that.isLoading = false;
  
              if (res.success) {
                that.getIdFunction();
                that.selected = [];
                that.tot_mtrs = 0;
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                swal({
                  title: "Click YES for Sticker Print?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes!",
                  cancelButtonText: "No",
                })
                  .then(() => {
                    that.loadeditBalBitPrintList(res.bal_id);
                  })
                  .catch(() => {
                    let tabObj = {
                      action: "CloseTab",
                      params: {},
                    };
                    that.tabUpdateEvent.emit(tabObj);
                  });
              }
            });
        });
      },setTimemm);
      
      
      
    } else {
      swal("Select Atleast One Bit");
    }
  }
  loadeditBalBitRePrintList(row){
    this.loadeditBalBitPrintList(row.rgrn_id);
  }
  loadeditBalBitPrintList(bal_id) {
    let params = {
      bal_id: bal_id,
      stock_type: "BALANCE BIT",
    };
    let that = this;
    that.jgrn
      .getEditBalBitList(params)
      .then((res: any) => {
        that.data = res.data;
        var row = res.data[0];
        // that.calcTotal();
        // that.calcQty();
          swal({
            title:
              "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
          })
            .then(() => {
              that.clickPrint(row, res.data);
            })
            .catch(() => {});
      })
      .catch(() => {});
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn
      .jgrnprint(params)
      .then(function (res: any) {
          let tabObj = {
            action: "CloseTab",
            params: {},
          };
          that.tabUpdateEvent.emit(tabObj);
          let tabObj1 = {
            action: "NewTab",
            params: {
              tabName: "WO BALANCE BIT INWARD",
              title: "WO BALANCE BIT INWARD",
              tabParent: "WORK ORDERS",
              name: "WO BALANCE BIT INWARD"
            },
          };
          that.tabUpdateEvent.emit(tabObj1);
          that.gobacktoWoGroup();
      })
      .catch(() => {});
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/balanceBitInward/balanceBitInward.ts